import styled, { createGlobalStyle } from "styled-components"

export const Global = createGlobalStyle`
  :root {
    --paper: #ffffff;
    --wash: #edf3fb;
    --wash-strong: #d9e7f8;
    --navy: #163a6b;
    --navy-deep: #0d2a52;
    --sky: #a9c9f1;
    --ink: #000000;
    --text: #1f2933;
    --muted: #5b6673;
    --line: rgba(22, 58, 107, 0.18);
    --line-strong: rgba(22, 58, 107, 0.45);
    --green: #0f6b4f;
    --font-display: "Bricolage Grotesque", "Helvetica Neue", Arial, sans-serif;
    --font-body: "IBM Plex Sans", "Helvetica Neue", Arial, sans-serif;
    --radius: 4px;
    --header-height: 72px;
    --measure: 62ch;
    /* aliases kept for shared components */
    --color-primary: var(--navy);
    --color-primary-hover: var(--navy-deep);
    --color-primary-soft: var(--wash);
    --color-accent: var(--navy);
    --color-text: var(--text);
    --color-muted: var(--muted);
    --color-bg: var(--paper);
    --color-bg-soft: var(--wash);
    --color-border: var(--line);
    --color-success: var(--green);
  }
  *, *::before, *::after { box-sizing: border-box; }
  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    scroll-behavior: smooth;
    scroll-padding-top: calc(var(--header-height) + 24px);
  }
  body {
    margin: 0;
    font-family: var(--font-body);
    font-size: 1.0625rem;
    line-height: 1.6;
    color: var(--text);
    background: var(--paper);
    -webkit-font-smoothing: antialiased;
    overflow-wrap: break-word;
    font-feature-settings: "kern", "liga";
  }
  [hidden] { display: none !important; }
  .sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }
  img, svg, video { max-width: 100%; height: auto; display: block; }
  h1, h2, h3 {
    margin: 0 0 0.5em;
    font-family: var(--font-display);
    font-weight: 700;
    font-optical-sizing: auto;
    color: var(--ink);
    letter-spacing: -0.02em;
  }
  h1 { font-size: clamp(2.2rem, 1.1rem + 3.2vw, 3.5rem); line-height: 1.04; font-weight: 800; }
  h2 { font-size: clamp(2rem, 1.3rem + 2.2vw, 3rem); line-height: 1.06; }
  h3 { font-size: clamp(1.35rem, 1.15rem + 0.6vw, 1.7rem); line-height: 1.15; letter-spacing: -0.01em; }
  h4 { margin: 0 0 0.4em; font-family: var(--font-body); font-weight: 600; font-size: 1.0625rem; line-height: 1.4; color: var(--ink); }
  p { margin: 0 0 1.25rem; }
  ul, ol { margin: 0 0 1.25rem; padding-left: 1.25rem; }
  li { margin-bottom: 0.4rem; }
  a { color: var(--navy); text-decoration: underline; text-decoration-thickness: 1.5px; text-underline-offset: 0.18em; }
  a:hover { text-decoration-thickness: 2.5px; }
  strong, b { font-weight: 600; }
  small { font-size: 0.9375rem; }
  blockquote, figure { margin: 0; }
  button, input, select, textarea { font: inherit; color: inherit; }
  :focus-visible { outline: 3px solid var(--navy); outline-offset: 3px; }
  :focus:not(:focus-visible) { outline: none; }
  section[tabindex="-1"]:focus, article[tabindex="-1"]:focus, li[tabindex="-1"]:focus, main:focus { outline: none; }
  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`

export const SkipLink = styled.a`
  position: absolute;
  top: -100px;
  left: 16px;
  z-index: 1000;
  padding: 0.75rem 1rem;
  background: var(--navy);
  color: #fff;
  border-radius: var(--radius);
  font-weight: 600;
  text-decoration: none;
  &:focus {
    top: 16px;
  }
`
